import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";

import { NormativeHelp } from "./NormativeHelp";

const mapStatToProps = (state: FullFormState) => ({
    normativeUrl: state.settings.normativeUrl,
    isReadOnly: state.settings.isReadOnly,
});

export const NormativeHelpContainer = connect(mapStatToProps)(NormativeHelp);
